// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/mutation-connect-api-token.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_Connection(
  $app_id: uuid!
  $token: String!
  $connection_properties: jsonb!
  $location_id: uuid!
  $expires_at: date
  $connection_id: uuid
) {
  apps_connect_api_token(
    app_id: $app_id
    token: $token
    connection_properties: $connection_properties
    location_id: $location_id
    expires_at: $expires_at
    connection_id: $connection_id
  ) {
    connection_id
  }
}

`